import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SizeDetectorComponent } from './size-detector/size-detector.component';
import { ToastModule } from 'primeng/toast';
import Lara from '@primeuix/themes/lara';

@NgModule({
  declarations: [AppComponent, SizeDetectorComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    FontAwesomeModule,
    ToastModule,
  ],
  providers: [
    MessageService,
    providePrimeNG({ theme: { preset: Lara, options: { darkModeSelector: false } } }),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
